module.exports = __webpack_public_path__ + "static/media/stylebee.8ccc730b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/brand-logos/stylebee.svg
// module id = 1061
// module chunks = 0